export default __webpack_public_path__ + "static/media/ic_anzor_40.232d4fde.svg";